export const DYNAMIC_REQUESTS_PATH = "/dynamic-requests/:type";
